import styled from 'styled-components';
import { Space, Popup } from '@cashfree-intl/coherent';

export const StyledBankWrapper = styled.div`
  padding: 1rem 1.2rem;
  border: 1px solid var(--TABLE_COLUMN);
  margin-top: 1rem;
`;

export const StyledTag = styled.span`
  background-color: var(--DISABLED);
  padding: 0.188rem 0.6rem;
  color: var(--SECONDARY_LIGHT);
  border-radius: 0.25rem;
`;

export const StyledSpace = styled(Space)`
  min-width: 300px;
`;

export const StyledPopup = styled(Popup)`
  &.ui.popup {
    background-color: var(--BACKGROUND_LIGHT);
    &:before {
      background-color: var(--BACKGROUND_LIGHT);
    }
  }
`;
